<div class="filter">

  <div
    class="filter__item">
    <app-amount-range
      [filterSumFrom]="filterSumFrom"
      [filterSumTo]="filterSumTo"
      title="{{'FILTERS.SUM' | translate}}">
    </app-amount-range>
  </div>
  <div
    *ngIf="filterCurrencies"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'currencies'"
      [filter]="filterCurrencies">
    </app-filter-select>
  </div>
  <div
    *ngIf="filterBanks"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'banks'"
      [filter]="filterBanks">
    </app-filter-select>
  </div>
  <div
    class="filter__item">
    <app-period
      [filterStart]="filterStart"
      [filterEnd]="filterEnd"
      title="{{'FILTERS.PERIOD' | translate}}">
    </app-period>
  </div>
</div>
